/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuButton, NeuNavVertical } from '@neutron/react';

export const HistorySideNavVertical = styled(NeuNavVertical)`
  flex: 0 0 200px;
  box-shadow: rgba(0, 0, 0, 0.15) 0 2px 4px;
  --nav-width-drawer: clamp(200px, 25vw, 200px);
`;
